import { call, put, takeEvery } from 'redux-saga/effects'
import { generateReport } from '../../helpers/reports-helper';

import {
  GET_LASTTRANSACTION_REQUESTED,
  GET_LASTTRANSACTIONBATCH_REQUESTED,
  EDIT_TRANSACTION_REQUESTED
} from '../actions/actionTypes'
import {
  getLastTransactionSuccess,
  getLastTransactionFailed,
  getLastTransactionBatchSuccess,
  getLastTransactionBatchFailed,
  editTransactionSuccess,
  editTransactionFailed
} from '../actions/transactionsAction'
import { messages } from '../../helpers/messages'
import { transactionsService } from '../../services/transactions-service'
import { getListUsers } from './userSaga'

const getLastTransaction = async payload =>
  await transactionsService
    .getLastTransaction(payload)
    .then(({ data }) => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages["0"]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })

const getLastTransactionBatch = async payload =>
  await transactionsService
    .getLastTransactionBatch(payload)
    .then(({ data }) => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages["0"]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })

const editTransaction = async payload =>
  await transactionsService
    .editTransaction(payload)
    .then(({ data }) => data)
    .catch(error => {
      if (error.response) {
        let errorData = error.response.data
        let commonError = messages["0"]
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode]
        }
        throw commonError
      }
    })


function* fetchGetLastTransaction({ payload }) {
  try {
    let transaction = yield call(getLastTransaction, payload)

    if (transaction.id !== null && transaction.documentNumber !== null) {
      if (transaction.userId) {
        const users = yield call(getListUsers, transaction.userId)
        if (users.users && users.users.length) {
          transaction.user = users.users[0];
        }
      }
    }

    yield put(getLastTransactionSuccess(transaction))
  } catch (error) {
    yield put(getLastTransactionFailed(error))
  }
}

function* fetchGetLastTransactionBatch({ payload }) {
  try {
    let transaction = yield call(getLastTransactionBatch, payload)

    if (transaction.id !== null && transaction.documentNumber !== null) {
      if (transaction.userId) {
        const users = yield call(getListUsers, transaction.userId)
        if (users.users && users.users.length) {
          transaction.user = users.users[0];
        }
      }
    }

    yield put(getLastTransactionBatchSuccess(transaction))
  } catch (error) {
    yield put(getLastTransactionBatchFailed(error))
  }
}

function* fetchEditTransaction({ payload }) {
  try {
    let transaction = yield call(editTransaction, payload.data)

    let {type, id:transactionId, accepted: {label: accepted}, attachment, additionalInfo, description, passport:document} = payload.reportData;
    if (type === "CREDIT") {
      yield call (
        generateReport,
        "TRANSACTION_CREDIT", 
        {
          transactionId,
          accepted,
          attachment,
          description
        }
      )
    } else {
      yield call (
        generateReport,
        "TRANSACTION_DEBIT",
        {
          transactionId,
          accepted,
          attachment,
          additionalInfo,
          document,
          description
        }
      )
    }
    yield put(editTransactionSuccess(transaction))
  } catch (error) {
    yield put(editTransactionFailed(error))
  }
}

function* getLastTransactionSaga() {
  yield takeEvery(GET_LASTTRANSACTION_REQUESTED, fetchGetLastTransaction)
}

function* getLastTransactionBatchSaga() {
  yield takeEvery(GET_LASTTRANSACTIONBATCH_REQUESTED, fetchGetLastTransactionBatch)
}

function* editTransactionSaga() {
  yield takeEvery(EDIT_TRANSACTION_REQUESTED, fetchEditTransaction)
}

export {
  getLastTransactionSaga,
  getLastTransactionBatchSaga,
  editTransactionSaga
}
